module.exports = __webpack_public_path__ + "img/pt.b908edae.svg";